import React from "react";
import { getManualState, setManualState } from "../config/Drop";

export default function Admin() {
  const cur = getManualState();

  const set = (v) => {
    setManualState(v);
    window.location.reload();
  };

  return (
    <div style={{ padding: 24, fontFamily: '"IBM Plex Mono", "Courier New", monospace' }}>
      <h3>Admin</h3>
      <p>Current: <b>{cur}</b></p>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <button onClick={() => set("auto")}>auto</button>
        <button onClick={() => set("open")}>open</button>
        <button onClick={() => set("closed_pre")}>closed (countdown)</button>
        <button onClick={() => set("closed_post")}>closed (subscribe)</button>
      </div>

      <p style={{ marginTop: 12, opacity: 0.7 }}>
        Tip: mets “closed_post” quand tu veux fermer le site après le drop.
      </p>
    </div>
  );
}